import { OrderHandoverContractSignFeaturePage } from "..";

/** 合同签署页路由入口。 */
export function OrderHandoverContractSignPage() {
  return <OrderHandoverContractSignFeaturePage />;
}
